<script>
import { library } from "@common/library/library";
import { componentStore } from "@common/componentStore/componentStore";

const customConfig = {
    cId: "custom",
    cType: "custom",
    cTitle: "Custom",
    cTemplate: `<div :id="cId" class="custom">
                </div>`,
    dsId: {
        type: 'dropdown',
        placeholder: "Select a dataset",
        onchange: "selectDataset",
        filterBarPlaceholder: "Search here",
        popupHeight: "220px",
        allowFiltering: true,
        default: false,
        fields: { text: 'cTitle', value: 'dsId' }
    },
    requests: [],
};

const customCmp = {
    name: 'custom',
    data() {
        return {
            settings: {},
            data: []
        };
    },
    methods: {
        async onPropsUpdate() {
            let config = await componentStore.getConfig(this.cId);
            let passedSettings = this.settings;
            let settings = {};
            if (passedSettings) {
                settings = {
                    ...config,
                    ...passedSettings
                };
            } else {
                settings = {
                    ...config
                };
            }
            this.settings = settings;
            this.getDataFromRequests();
            this.getDataFromDataset();
        },
        async getDataFromRequests() {
            if (!this.settings || !this.settings.requests || !this.settings.requests.length) return;
            for (let i in this.settings.requests) {
                if (i === 'length') continue;
                if (!this.settings.requests[i].args || !this.settings.requests[i].args.length) continue;
                this.sDs.post.apply(null, this.settings.requests[i].args).then((response) => {
                    if (response && response.status === 'success') {
                        let tmp = library.cloneObj(this.data);
                        let property = this.settings.requests[i].as ? this.settings.requests[i].as : this.settings.requests[i].args[0];
                        tmp[property] = response.data;
                        this.data = { ...tmp };
                    }
                });
            }
        },
        async getDataFromDataset() {
            if (this.settings.dsId && this.settings.dsId !== '0') {
                library.showLoadingIndicator(this.cId);
                if (typeof this.settings.addParams !== 'object') {
                    this.settings.addParams = {
                        useCaCode: 1
                    };
                }
                this.sDs.post('sds_getDataset', this.settings.dsId, this.settings.pspId, this.settings.isLogBook, this.settings.parentRecords, this.settings.addParams).then((response) => {
                    if (response && response.status === 'success') {
                        let data = [];
                        for (let i in response.data) {
                            if (i === 'length') continue;
                            data.push(response.data[i]);
                        }
                        let tmp = library.cloneObj(this.data);
                        tmp['dataset'] = data;
                        this.data = tmp;
                    }
                    library.hideLoadingIndicator(this.cId);
                });
            }
        }
    }
};

componentStore.initComponent(customCmp, customConfig);
export { customConfig, customCmp };
export default customCmp;
</script>
